import { EmailAddress } from '@constants';
import { BackButton } from '../buttons';
import classes from './index.module.css';

export const SeelEmail = ({ style = {} }) => (
  <a
    href={`mailto:${EmailAddress.Seel}`}
    style={style}
    className={classes.email}
  >
    {EmailAddress.Seel}
  </a>
);

export const Note = ({
  children,
  icon = '',
  hasBackBtn = true,
  title = '',
  subTitle = '',
  backStep,
  style = {},
  navigateUrl,
}) => (
  <section className={classes.content} style={style}>
    {icon ? <img src={icon} alt="" className={classes.icon} /> : null}
    {title ? <section className={classes.title}>{title}</section> : null}
    {subTitle ? <section className={classes.sub_title}>{subTitle}</section> : null}
    {children}
    {hasBackBtn ? <BackButton backStep={backStep} navigateUrl={navigateUrl} /> : null}
  </section>
);
